//@flow
import React from 'react';
import { Container } from 'flux/utils';
import MembershipStore from '../../Stores/Membership/membershipStore';
import CustomerStore from '../../Stores/Customer/customer';
import ExperimentsStore from '../../Stores/Experiments/experimentsStore';
import MktgStore from '../../Stores/Mktg/mktgStore';
import QuoteStore from '../../Stores/Quote';
import SessionStore from '../../Stores/Session/session';
import DefaultBanner from '../../Homepage/components/DefaultBanner.react';
import { withRouter } from 'react-router';

import type MembershipPlanModel from '../../Stores/Membership/membershipPlanModel';
import type {BannerConfig} from '../../Stores/Mktg/mktgModelInterfaces';
import type { ContextRouter } from 'react-router';

type Props = ContextRouter;

type State = {
  bannerConfig:?BannerConfig,
  promoUnlockEnabled:boolean,
  membershipPlan:MembershipPlanModel,
};

class CatalogBanner extends React.Component<Props, State> {
  static getStores() {
    return [
      MembershipStore,
      ExperimentsStore,
      MktgStore,
      QuoteStore,
      CustomerStore,
      SessionStore,
    ];
  }

  static calculateState(prevState:State, props:Props):State {
    const quote = QuoteStore.getQuote();
    const newMemberPlanCode = quote.getNewMembershipPlanCode();
    const membershipPlan = MembershipStore.getMembershipPlan(newMemberPlanCode);
    const customer = CustomerStore.getCustomer();
    const isMember = customer && customer.hasMembership();
    const isLoggedIn = SessionStore.isLoggedIn();
    const path = props.location.pathname;
    const query = props.location.search;

    const bannerConfig = MktgStore.getBannerConfig({
      isMember,
      isLoggedIn,
      path,
      query,
    });

    return {
      membershipPlan,
      bannerConfig,
      promoUnlockEnabled: ExperimentsStore.isEnabled('banner_get_promo'),
    };
  }

  render() {
    return (
      <DefaultBanner
        bannerConfig={this.state.bannerConfig}
        promoUnlockEnabled={this.state.promoUnlockEnabled}
        membershipPlan={this.state.membershipPlan}
      />
    );
  }
}

export default withRouter(Container.create(CatalogBanner, {withProps: true}));
